import { createSelector } from '@ngrx/store';

export const isReportLoadingState = createSelector(
    (state: any) => state.reports,
    (state: any) => state.getIn(['createReport', 'isLoading'])
);
